<template>
    <div v-if="show" class="container">
        <h3>{{ $translate('faq_about', 'Vanliga frågor om {title}').replace('{title}', document.data.title) }}</h3>
        <faq-grid :faq="document.data.faq" />
    </div>
</template>
<script>
import FaqGrid from '@/components/FaqGrid.vue';
export default {
    components: {
        FaqGrid
    },
    props: {
        document: {
            type: Object,
            required: true,
        }
    },
    computed: {
        faq() {
            return this.document.data.faq
                .filter(faq => faq.question && faq.answer);
        },
        show() {
            return this.faq.length > 0;
        }
    }
}
</script>